// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-995de8f6] .el-table-emptyImg .empty{margin-top:30px;margin-bottom:20px}", ""]);
// Exports
module.exports = exports;
